import AuthAPI from '@/apis/business/account/auth-student-api.js'
import StudentAPI from '@/apis/business/student/student-api.js'

export default {
  namespaced: true,
  state: {
    /**
     * Thông tin người dùng truyền lên
     */
    account: {
      UserId: '',
      FullName: '',
      UserName: '',
      Password: '',
      PhoneNumber: '',
      IsShowCaptcha: false,
      CaptchaId: '',
      CaptchaValue: '',
      ConfirmPassword: '',
      ForgotPasswordKey: '',
      Image: '',
      Code: '',
      ExpiredTime: 0,
      Birthday: null,
      OrganizationID: null
    },
    students: [],
    queryText: '',
    accountStudent: {}
  },
  getters: {},
  mutations: {
    /**
     * @author PVThang
     * @description set giá trị cho account
     * @param {*} state
     * @param {*} student
     */
    setStudent (state, student) {
      state.account = { ...student }
    },

    /**
     * set giá trị cho account khi join lớp
     * @param {*} state
     * @param {*} accountStudent
     */
    setAccountStudent (state, accountStudent) {
      state.accountStudent = { ...accountStudent }
    },

    /**
     * @author PVThang
     * @description set giá trị cho danh sách học sinh
     * @param {*} state
     * @param {*} student
     */
    setStudents (state, students) {
      state.students = students
    },

    /**
     * @author PVThang
     * @description set giá trị queryText
     * @param {*} state
     * @param {*} newVal
     */
    setQueryText (state, newVal) {
      state.queryText = newVal
    }
  },
  actions: {
    /**
     * @description Học sinh đăng nhập
     * @param {*} context
     * @param {*} params
     * @returns
     */
    login (context, params) {
      return AuthAPI.postAsync('login', params)
    },

    /**
     * @description Lấy mã capcha
     * @param {*} context
     * @param {*} params
     * @returns
     */
    captcha (context, params) {
      return AuthAPI.getAsync('captcha')
    },

    /**
     * @description Học sinh đăng ký
     * @param {*} context
     * @param {*} params
     * @returns
     */
    register (context, params) {
      return AuthAPI.postAsync('register', params)
    },

    /**
     * @author PVThang
     * @description xác nhận đăng ký tài khoản
     * @param {*} context
     * @param {*} params
     * @returns
     */
    confirmRegister (context, params) {
      return AuthAPI.postAsync('register/confirm', params)
    },

    /**
     * @description Quên mật khẩu
     * @param {*} context
     * @param {*} params
     * @returns
     */
    forgotPassword (context, params) {
      return AuthAPI.postAsync('password/forgot', params)
    },

    /**
     * @description xác nhận otp
     * @param {*} context
     * @param {*} params
     * @returns
     */
    confirmPassword (context, params) {
      return AuthAPI.postAsync('password/confirm', params)
    },

    /**
     * @description Xác nhận mật khẩu mới
     * @param {*} context
     * @param {*} params
     * @returns
     */
    resetPassword (context, params) {
      return AuthAPI.postAsync('password/reset', params)
    },

    /**
     * Thay đổi mật khẩu
     * @param {*} context
     * @param {*} params
     * @returns
     */
    changePassword (context, params) {
      return AuthAPI.postAsync('password/change', params)
    },

    /**
     * @author PVThang
     * @description lấy thông tin học sinh theo userName
     * @param {*} context
     * @param {*} userName
     * @returns response từ server
     */
    async getStudent (context, userName) {
      return await AuthAPI.getAsync(userName)
    },

    /**
     * @description Cập nhật thông tin học sinh
     */
    updateStudent (context, params) {
      return new Promise((resolve, reject) => {
        StudentAPI.putAsync('', params).then((res) => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @author PVThang
     * @param {String} filterValue PhoneNumber/UserName/SISAPCode
     * @description Lấy danh sách học sinh theo giá trị filterValue
     */
    async getStudents (context, filterValue) {
      return await AuthAPI.getAsync(`filter/${filterValue}`)
    }
  }
}
